import { render } from "./Step3.vue?vue&type=template&id=3c490b8f&scoped=true"
import script from "./Step3.vue?vue&type=script&lang=js"
export * from "./Step3.vue?vue&type=script&lang=js"

import "./tailwind.css?vue&type=style&index=0&id=3c490b8f&scoped=true&lang=css&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c490b8f"]])

export default __exports__